import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('popover-next', {
  root: { states: ['fluid'] },
});
